import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import BuyingGuide from './components/BuyingGuide';
import Comparison from './components/Comparison';
import ProductGrid from './components/ProductGrid';
import AboutStory from './components/AboutStory';
import BundleBuilder from './components/BundleBuilder';
import Impact from './components/Impact';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

function App() {
  const [cartCount, setCartCount] = useState(0);

  const addToCart = () => {
    setCartCount(prev => prev + 1);
  };

  return (
    <div className="font-sans text-stone-900 bg-white selection:bg-teal-100 selection:text-teal-900">
      <Navbar cartCount={cartCount} />
      
      <main>
        <Hero />
        <BuyingGuide />
        <ProductGrid addToCart={addToCart} />
        <Comparison />
        <AboutStory />
        <BundleBuilder />
        <Impact />
        <FAQ />
      </main>

      <Footer />
    </div>
  );
}

export default App;